import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@mui/material';
import React from 'react';
import { NumericFormat } from 'react-number-format';
import PropTypes from 'prop-types';

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value
                    }
                });
            }}
            thousandSeparator={true}
            valueIsNumericString
            prefix="E"
        />
    );
});

NumberFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export default function BillDialog(props) {
    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>Bills</DialogTitle>
            <DialogContent>
                <DialogContentText>Fill in the form to add/edit Bills</DialogContentText>
                <Grid style={{ marginTop: '10px' }} container spacing={2}>
                    <Grid item xs={6}>
                        <TextField
                            value={props.supplier}
                            onChange={(e) => props.setSupplier(e.target.value)}
                            margin="dense"
                            id="name"
                            label="Supplier"
                            type="text"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={props.setBillDate}
                            onChange={(e) => props.setBillDate(e.target.value)}
                            margin="dense"
                            id="billdate"
                            label="Bill Date"
                            type="text"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={props.billDueDate}
                            onChange={(e) => props.setBillDueDate(e.target.value)}
                            margin="dense"
                            id="billduedate"
                            label="Bill Due Date"
                            type="text"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            InputProps={{
                                inputComponent: NumberFormatCustom
                            }}
                            value={props.billNumber}
                            onChange={(e) => props.setBillNumber(e.target.value)}
                            name="billNumber"
                            margin="dense"
                            id="billNumber"
                            label="Bill No."
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Subsidiary</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={props.subsidiary}
                                label="Subsidiary"
                                onChange={(e) => props.setSubsiary(e.target.value)}
                            >
                                <MenuItem value={'FMK'}>
                                    FMK
                                </MenuItem>
                                <MenuItem value={'BPDev'}>
                                    BPDev
                                </MenuItem>
                                <MenuItem value={'BPDRobotics'}>
                                    BPD Robotics
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={props.description}
                            onChange={(e) => props.setDescription(e.target.description)}
                            margin="dense"
                            id="description"
                            label="Description"
                            type="text"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            InputProps={{
                                inputComponent: NumberFormatCustom
                            }}
                            value={props.amount}
                            onChange={(e) => props.setAmount(e.target.value)}
                            name="amount"
                            margin="dense"
                            id="amount"
                            label="Amount"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Cancel</Button>
                <Button onClick={props.handleSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}
